export enum ReviewTradeModes {
  Approve = 2,
  Amend = 3,
  Reject = 4,
}
